import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Skeleton/Skeleton.tsx
import { useReportLoading } from "../../../hooks/useLoadingActivity.mjs";
import { jsx } from "react/jsx-runtime";
var skeletonVariants = cva("buyscout-skeleton", {
  variants: {
    variant: {
      text: "buyscout-skeleton--text",
      rect: "buyscout-skeleton--rect",
      circle: "buyscout-skeleton--circle"
    },
    inline: {
      true: "buyscout-skeleton--inline",
      false: ""
    }
  },
  defaultVariants: {
    variant: "text",
    inline: false
  }
});
function Skeleton({
  ref,
  ...props
}) {
  const { variant, inline, width, height, className, style, ...rest } = props;
  useReportLoading();
  const sizeStyle = {
    ...width !== void 0 && { width },
    ...height !== void 0 && { height },
    ...style
  };
  return /* @__PURE__ */ jsx(
    "span",
    {
      ref,
      className: skeletonVariants({ variant, inline, className }),
      style: sizeStyle,
      "aria-hidden": "true",
      ...rest
    }
  );
}
Skeleton.displayName = "Skeleton";
export {
  Skeleton
};
//# sourceMappingURL=Skeleton.mjs.map